export default {
  BUAdvancePayment: {
    Title: 'Bảng kê thanh toán tạm ứng',
    GenerateVoucherTreasuryWithdraw: 'Sinh phiếu rút tiền kho bạc',
    GenerateVoucherTreasuryWithdrawContent: 'Bạn có muốn cộng gộp theo Mục lục ngân sách không?',
    ShowNotiCheckData: {
      Message: 'Bạn phải chọn ít nhất một chứng từ',
      Title: 'Cất không thành công',
      Button: 'Đồng ý',
    },
    ShowNotiCheckEmptyData: {
      Message: 'Bảng kê chưa được kho bạc duyệt. Không thể thực hiện thanh toán.',
      Title: 'Không hợp lệ',
      Button: 'Đồng ý',
    },
    ShowNotiCheckRefNo: {
      Message: 'Số bảng kê không được để trống',
      Title: 'Cất không thành công',
      Button: 'Đồng ý',
    },
    ShowNotiCheckRefDate: {
      Message: 'Ngày bảng kê không được nhỏ hơn ngày hạch toán của các chứng từ đã chọn.',
      Title: 'Cất không thành công',
      Button: 'Đồng ý',
    },
    ShowNotiCheckPayment: {
      Message: 'Bạn phải chọn ít nhất 1 chứng từ',
      Title: 'Thanh toán không thành công',
      Button: 'Đồng ý',
    },
  },
  BUAdvanceExpence: {
    Title: 'Bảng kê chứng từ thực chi',
    GenerateVoucherTreasuryWithdraw: 'Sinh phiếu rút tiền kho bạc',
  },
  MonthAdjustment: 'Tháng chỉnh lý quyết toán',
  Content: 'Nội dung',
  ListDate: 'Ngày bảng kê',
  ListNumber: 'Số bảng kê',
  Payment: 'Thanh toán',
  ViewVoucher: 'Xem chứng từ',
  CancelPayment: 'Hủy thanh toán',
  VoucherReference: 'CT Tham chiếu',
  ConfirmNoAccounting111:
    'Không có dòng nào hạch toán Có Tài khoản 111 nên không sinh được giấy rút. Vui lòng kiểm lại.',
  TitleConfirmNoAccounting111: 'Không hợp lệ',
};
